
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import Message from '@/components/message.vue';
	import Dialog from '@/components/dialog.vue';
	import UploadImg from '@/components/upload-img.vue';
	import previewImg from '@/components/previewImg.vue';
  import {
    custompagecustompagelist,
    custompagecustompagedelete,
    custompagecustompagesetshareimg,
    mallshopdecoratesethome,
    mallshopdecoratesetSort,
    custompagesuspendedBuoyInfo,
    custompagesuspendedBuoySave
  } from '@/api/material'
  import qrCode from '@/components/qrCode.vue';
  import {imgHost} from '@/utils/config';
	import ChoosePages from '@/components/choosepages/choosepages.vue';
	import Switch from '@/components/switch.vue';
	import PickerDate from '@/components/picker-date.vue';
  import {
    getSearchDate,
    nextDay,
    chooseLinkConvert,
    getDataConvert
  } from "@/utils"
  @Component({  
    name: '',
    components: {
      PageFooter,
			'slz-message': Message,
			'slz-dialog': Dialog,
			UploadImg,
      previewImg,
      qrCode,
      ChoosePages,
			'slz-switch': Switch,
      PickerDate,
    }
  })

  export default class ProductList extends Vue {
    private imgHost = imgHost
    private keywords = ''
    private filterTime = ''
    private tablelist:any = []
    private tableloading = false
    private pageSize = 20
    private pageNo = 1
    private total = 0
    private rowmsg:any = {}
    private changeimgShow = false
    private delShow = false
    private showPreview = false
    private fileType = 'image'
    private currentUrl = ''
    private showcode = false
    private codemsg:any = {}
    private setTipsShow = false
    private ShowFloatingBuoy = false
    private FloatingBuoyLoading = false
    private result:any = {
      SuspendedBuoyImg:[],
      SuspendedBuoyImgComplete:'',
      SuspendedBuoyRelationId:'',
      SuspendedBuoyRelationValue:'',
      SuspendedBuoyRelationTypeValue:'',
      SuspendedBuoyRelationType:'',
      SuspendedBuoyStartTime:'',
      SuspendedBuoyEndTime:'',
      SuspendedBuoyIsDisplay:true,
      SuspendedBuoyPath:'',
    }
    private FloatingBuoyMsg:any = {}
    private chooseShow = false
    private chooseMsg:any = {}

    private mounted () {
      // console.log(imgHost)
      this.filterTime = getSearchDate(1,false).join('/')
      this.getsuspendedBuoyInfo()
      this.gettablelist()
    }



    private async getsuspendedBuoyInfo(){
      try{
        let res = await custompagesuspendedBuoyInfo({})
        if(res.IsSuccess){
          this.chooseMsg = {
            ...chooseLinkConvert(res.Result.SuspendedBuoyRelationType),
            Id:res.Result.SuspendedBuoyRelationId
          }
          
          this.result = {
            ...res.Result,
            SuspendedBuoyImg:res.Result.SuspendedBuoyImg?[res.Result.SuspendedBuoyImg]:[],
            SuspendedBuoyRelationId:res.Result.SuspendedBuoyRelationId||'',
            SuspendedBuoyRelationType:res.Result.SuspendedBuoyRelationType||'',
            SuspendedBuoyRelationValue:res.Result.SuspendedBuoyRelationValue||''
          }

          this.FloatingBuoyMsg = JSON.parse(JSON.stringify(this.result))
        }
      }finally{
        //
      }
    }
    private async SetConfirm(){
      if(!this.FloatingBuoyMsg.SuspendedBuoyImg||!this.FloatingBuoyMsg.SuspendedBuoyImg.length){
        this.$message.error('请上传图标')
        return 
      }
			if((this.FloatingBuoyMsg.SuspendedBuoyStartTime&&!this.FloatingBuoyMsg.SuspendedBuoyEndTime)||(!this.FloatingBuoyMsg.SuspendedBuoyStartTime&&this.FloatingBuoyMsg.SuspendedBuoyEndTime)){
				this.$message.error('请完善显示时间段')
				return
			}
      if((this.FloatingBuoyMsg.SuspendedBuoyStartTime||this.FloatingBuoyMsg.SuspendedBuoyEndTime)&&
        (new Date(this.FloatingBuoyMsg.SuspendedBuoyStartTime).getTime()>=new Date(this.FloatingBuoyMsg.SuspendedBuoyEndTime).getTime())){
				this.$message.error('结束时间不可早于开始时间')
				return
			}
      try{
        this.FloatingBuoyLoading = true
        // console.log(this.FloatingBuoyMsg)
        let res = await custompagesuspendedBuoySave({
          Info:{
            ...this.FloatingBuoyMsg,
            SuspendedBuoyImg:this.FloatingBuoyMsg.SuspendedBuoyImg[0]
          }
        })
        if(res.IsSuccess){
          this.$message.success('保存成功')
          this.getsuspendedBuoyInfo()
          this.ShowFloatingBuoy = false
        }
      }finally{
        this.FloatingBuoyLoading = false
      }
    }
    private getdata(e){
      this.chooseMsg = e
      this.FloatingBuoyMsg.SuspendedBuoyRelationType = getDataConvert(e.pagetype,e.subdivideType)
      // console.log(e)
      this.FloatingBuoyMsg.SuspendedBuoyRelationTypeValue = e.pagetypelabel
			this.FloatingBuoyMsg.SuspendedBuoyRelationId = e.Id
			this.FloatingBuoyMsg.SuspendedBuoyRelationValue = e.label
			this.FloatingBuoyMsg.SuspendedBuoyPath = e.pageurl
			this.chooseShow = false
    }
		private clearValue(){
			this.FloatingBuoyMsg.SuspendedBuoyRelationType = ''
			this.FloatingBuoyMsg.SuspendedBuoyRelationTypeValue = ''
			this.FloatingBuoyMsg.SuspendedBuoyRelationId = ''
			this.FloatingBuoyMsg.SuspendedBuoyRelationValue = ''
			this.FloatingBuoyMsg.SuspendedBuoyPath = ''
			this.chooseMsg = {}
		}
    private changetype(){
      this.chooseShow = true
    }
    private async saveSort(){
      try{
        let res:any = await mallshopdecoratesetSort({
          Id:this.rowmsg.Id,
          Sort:this.rowmsg.Sort
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.gettablelist()
        }
      }finally{
        //
      }
    }
    private showpopover(row){
      this.rowmsg = JSON.parse(JSON.stringify(row))
    }
    private setPageIndex(row){
      this.rowmsg = row
      this.setTipsShow = true
    }
    private async confirmSetPageIndex(){
      try{
        this.tableloading = true
        let res=  await mallshopdecoratesethome({
          Id:this.rowmsg.Id
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.gettablelist()
        }
      }finally{
        this.tableloading = false
      }
    }
    private previewcode(row){
      this.rowmsg = row
      this.codemsg = {
        type:3,
        Id:row.Id,
        title:row.PageName
      }
      this.showcode = true
    }
    private showimg(row){
      this.currentUrl = this.imgHost+row.ShareImgUrl
      this.showPreview = true
    }
    private todetail(row){
      this.$router.push({
        path:'decoration',
        query:{
          Id:row.Id
        }
      })
    }
    private async confirmdel(){
      try{
        let data:any = {
          Id:this.rowmsg.Id
        }
        let res:any = await custompagecustompagedelete(data)
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.delShow = false
          this.gettablelist()
        }
      }finally{
        //
      }
    }
    private delrow(row){
      this.rowmsg = row
      this.delShow = true
    }
    private async confirmchange(){
      try{
        let data:any = {
          Id:this.rowmsg.Id,
          ShareImgUrl:this.rowmsg.ShareImgUrl
        }
        let res:any = await custompagecustompagesetshareimg(data)
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.changeimgShow = false
          this.gettablelist()
        }
      }finally{
        //
      }
    }
    private uploadSuc(list){
      this.rowmsg.ShareImgUrl = list[0]
    }
    private uploadSuc2(list,key){
      this.FloatingBuoyMsg[key] = list
    }
    private setimg(row){
      this.rowmsg = JSON.parse(JSON.stringify(row))
      this.changeimgShow = true
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data:any = {
          PageName:this.keywords,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize,
          StartTime:'',
          EndTime:'',
          IsList:true
        }
        if(this.filterTime){
          let t = this.filterTime.split('/')
          data.StartTime = t[0]
          data.EndTime = nextDay(t[1],1)
        }
        let res:any = await custompagecustompagelist(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results.map(v=>{
            v.showSort = false
            return v
          })
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
  }
